import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* HERO */}
      <section className="home-hero">
        <div className="hero-bg"></div>
        <div className="hero-bg-dots"></div>
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>

        <div className="hero-content">
          <div className="hero-badge">
            <span className="dot"></span>
            Trusted since 2018 · 7+ Years of Excellence
          </div>
          <h1>Powering Your<br /><span>Workforce, Technology</span><br />&amp; Growth</h1>
          <p>
            Krishpar Technologies delivers end-to-end IT &amp; General Staffing, Workforce Solutions, Payroll Management, and HR Products like Emploi and PeopleX HR &mdash; helping businesses build stronger teams, streamline operations, and scale efficiently.
          </p>
          <div className="hero-actions">
            {/* <Link to="/it-services" className="btn-primary">Discover Our Story ↗</Link> */}
            <button className="btn-outline" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
              Our Services
            </button>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card-stack">
            <div className="stat-card float-1">
              <div className="stat-label">Founded</div>
              <div className="stat-value">2018</div>
              <div className="stat-sub">Chennai, India</div>
            </div>

            <div className="stat-card main">
              <div className="main-card-grid">
                <div className="mini-stat">
                  <div className="num">7<span style={{ fontSize: '18px' }}>+</span></div>
                  <div className="lbl">Years Active</div>
                </div>
                <div className="divider-v"></div>
                <div className="mini-stat">
                  <div className="num">5000<span style={{ fontSize: '18px' }}>+</span></div>
                  <div className="lbl">Placements</div>
                </div>
              </div>
              <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px' }}>
                <div className="stat-label" style={{ marginBottom: '10px' }}>Core Services</div>
                <div className="services-row">
                  <span className="service-pill pill-green">IT &amp; General Staffing</span>
                  <span className="service-pill pill-blue">Staff Augmentation</span>
                  <span className="service-pill pill-green">IT Services</span>
                  <span className="service-pill pill-blue">Workforce Solutions</span>
                  <span className="service-pill pill-green">Payroll Management</span>
                  <span className="service-pill pill-blue">HR Products</span>
                </div>
              </div>
            </div>

            <div className="stat-card float-2">
              <div className="stat-label">Active Products</div>
              <div className="stat-value" style={{ fontSize: '20px' }}>Emploi &amp; PeopleX HR</div>
              <div className="stat-sub">HR Platforms</div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS BAND */}
      <div className="stats-band">
        <div className="stat-item-home">
          <div className="num">7<span className="plus">+</span></div>
          <div className="lbl">Years in Industry</div>
        </div>
        <div className="stat-item-home">
          <div className="num">5000<span className="plus">+</span></div>
          <div className="lbl">Successful Placements</div>
        </div>
        <div className="stat-item-home">
          <div className="num">2</div>
          <div className="lbl">Flagship HR Products</div>
        </div>
        <div className="stat-item-home">
          <div className="num">100<span className="plus">+</span></div>
          <div className="lbl">Client Organisations</div>
        </div>
      </div>

      {/* SERVICES */}
      <section className="services-section" id="services">
        <div className="section-head center">
          <span className="section-label" style={{ textAlign: 'center' }}>What We Do</span>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Comprehensive HR &amp; Workforce Solutions</h2>
          <p className="section-sub">
            From finding the right talent to managing every payroll cycle — we handle the complexity
            so you can focus on growth.
          </p>
        </div>
        <div className="services-grid">
          <Link to="/general-staffing" className="service-card">
            <div className="service-icon icon-green">🎯</div>
            <h3>Staffing Solutions</h3>
            <p>
              We provide flexible staffing solutions tailored to your business needs — contract,
              temporary, or permanent. Our vast talent network ensures you always have the right
              people at the right time.
            </p>
          </Link>
          <Link to="/krishpar-hiring" className="service-card">
            <div className="service-icon icon-blue">🔍</div>
            <h3>Recruitment Services</h3>
            <p>
              End-to-end recruitment across sectors — IT, finance, manufacturing, and more.
              We handle sourcing, screening, and placement with precision to reduce your time-to-hire significantly.
            </p>
          </Link>
          <Link to="/payroll-services" className="service-card">
            <div className="service-icon icon-green">💼</div>
            <h3>Payroll Management</h3>
            <p>
              Accurate, compliant, and timely payroll processing. We manage salary disbursements,
              tax filings, PF/ESI compliance, and statutory reporting — fully transparent and error-free.
            </p>
          </Link>
          <Link to="/hr-compliance-advisory" className="service-card">
            <div className="service-icon icon-blue">📊</div>
            <h3>HR Compliance &amp; Advisory</h3>
            <p>
              Stay ahead of regulatory changes. Our HR advisory team ensures your workforce solutions
              remain compliant with Indian labour laws, GST, and statutory requirements.
            </p>
          </Link>
          <Link to="/it-staffing-contracts" className="service-card">
            <div className="service-icon icon-green">🤝</div>
            <h3>Contract Staffing</h3>
            <p>
              Scale your workforce solutions up or down effortlessly. Our contract staffing model gives you
              operational agility while we handle all employment obligations and compliance.
            </p>
          </Link>
          <Link to="/emploi-product" className="service-card">
            <div className="service-icon icon-blue">🚀</div>
            <h3>HR Technology</h3>
            <p>
              Backed by our own HR platforms — Emploi and PeopleX HR — we digitise your entire HR
              lifecycle from onboarding to exit, bringing efficiency and visibility to every process.
            </p>
          </Link>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="products-section" id="products">
        <div className="section-head">
          <span className="section-label">Our Products</span>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Built In-House. Designed for Impact.</h2>
          <p className="section-sub">We don't just deliver HR services — we build the technology that powers them.</p>
        </div>
        <div className="products-grid">
          <div className="product-card green-card">
            <div className="product-tag">HR Platform</div>
            <h3>Emploi</h3>
            <p className="product-tagline">Redefining How Companies Find and Hire Talent</p>
            <p>
              A complete Human Resource Management platform — from onboarding and attendance
              to appraisals and exit management, all in one place.
            </p>
            <ul className="product-features">
              <li>Employee onboarding &amp; lifecycle management</li>
              <li>Attendance &amp; leave tracking</li>
              <li>Performance management &amp; appraisals</li>
              <li>Document management &amp; compliance</li>
              <li>Real-time HR dashboards &amp; analytics</li>
            </ul>
            <Link to="/emploi-product" className="btn-white green-text">Learn More →</Link>
            <div className="big-num" style={{ position: 'absolute', bottom: '-10px', right: '10px', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '90px', fontWeight: '800', opacity: '.1', color: 'white' }}>E</div>
          </div>
          <div className="product-card blue-card">
            <div className="product-tag">Payroll Platform</div>
            <h3>PeopleX HR</h3>
            <p className="product-tagline">Payroll That Works as Hard as You Do</p>
            <p>
              Intelligent payroll automation platform ensuring accurate, compliant, and on-time
              payroll processing with zero hassle.
            </p>
            <ul className="product-features">
              <li>Automated salary &amp; payslip generation</li>
              <li>PF, ESI, TDS &amp; statutory compliance</li>
              <li>Multi-company &amp; multi-location payroll</li>
              <li>Direct bank integration &amp; disbursement</li>
              <li>Comprehensive MIS reports &amp; audit trails</li>
            </ul>
            <Link to="/payroll-product" className="btn-white blue-text">Learn More →</Link>
            <div className="big-num" style={{ position: 'absolute', bottom: '-10px', right: '10px', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '90px', fontWeight: '800', opacity: '.1', color: 'white' }}>P</div>
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="why-section">
        <div className="why-grid">
          <div className="home-why-visual">
            <div className="why-img-box">
              <h3>7+ Years of Workforce Solutions Expertise</h3>
              <p>
                Since 2018, we've been at the forefront of HR services and technology in India —
                growing with our clients, solving real problems.
              </p>
              <div className="big-num">7</div>
            </div>
            <div className="badge-float">
              <div className="bf-num">100%</div>
              <div className="bf-lbl">Compliance Rate</div>
            </div>
          </div>
          <div>
            <span className="section-label" style={{ textAlign: 'start', justifyContent: 'start' }}>Why Krishpar</span>
            <h2 className="section-title" style={{ textAlign: 'start' }}>Why Companies<br />Choose Us</h2>
            <ul className="points">
              <li className="point-item">
                <div className="point-icon icon-green">🏆</div>
                <div>
                  <h4>Proven Track Record</h4>
                  <p>
                    Over 7 years of consistent service delivery, 500+ successful placements,
                    and a growing list of satisfied clients across industries.
                  </p>
                </div>
              </li>
              <li className="point-item">
                <div className="point-icon icon-blue">⚡</div>
                <div>
                  <h4>Technology-Backed Delivery</h4>
                  <p>
                    Our proprietary platforms — Emploi and PeopleX HR — mean faster turnarounds,
                    fewer errors, and complete visibility into your HR operations.
                  </p>
                </div>
              </li>
              <li className="point-item">
                <div className="point-icon icon-green">🛡️</div>
                <div>
                  <h4>Full Statutory Compliance</h4>
                  <p>
                    We stay current with all Indian labour laws and statutory requirements,
                    ensuring your business never faces regulatory risk.
                  </p>
                </div>
              </li>
              <li className="point-item">
                <div className="point-icon icon-blue">🤝</div>
                <div>
                  <h4>Dedicated Partnership</h4>
                  <p>
                    We work as an extension of your team — not just a vendor. Dedicated account
                    managers, responsive support, and a long-term growth mindset.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="cta-band">
        <h2 style={{ textAlign: 'center' }}>Ready to Transform Your Workforce Solutions?</h2>
        <p>Let's talk about how Krishpar Technologies can support your HR and payroll needs.</p>
        <div className="actions">
          <Link to="/contact" className="btn-primary">Get in Touch →</Link>
          <Link to="/emploi-product" className="btn-outline" style={{ 
            borderColor: 'rgba(255,255,255,.3)', 
            color: 'rgba(255,255,255,.8)', 
            textDecoration: 'none', 
            display: 'inline-block',
            transition: 'all 0.3s ease'
          }} 
          onMouseEnter={(e) => {
            e.target.style.borderColor = 'var(--green)';
            e.target.style.color = 'var(--green)';
            e.target.style.backgroundColor = 'transparent';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = 'rgba(255,255,255,.3)';
            e.target.style.color = 'rgba(255,255,255,.8)';
            e.target.style.backgroundColor = 'transparent';
          }}>
            View Our Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
